import { z } from 'zod'
import { serviceInputSchema } from '../../input/service-schema'
import { filterableStateSchema } from '../base'

// -------------------------
// Services State Validation
// -------------------------
export const serviceStateItemSchema = serviceInputSchema.extend({
  isSelected: z.boolean().optional()
})

export const serviceStateSchema = filterableStateSchema.extend({
  items: z.array(serviceStateItemSchema),
  selectedService: serviceStateItemSchema.nullable()
})

export const serviceActionValidation = {
  'services/setServices': z.object({
    services: z.array(serviceStateItemSchema),
    locationId: z.string()
  }),
  'services/updateService': serviceStateItemSchema,
  'services/setSelectedService': serviceStateItemSchema
} as const

// Type inference helpers
export type ServiceStateValidation = z.infer<typeof serviceStateSchema>
